var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"event-layout"},[_c('events-header',{attrs:{"container":false}}),_vm._v(" "),_c('nuxt'),_vm._v(" "),_c('modal',{attrs:{"name":"event"}})],1),_vm._v(" "),_c('chat'),_vm._v(" "),_c('toaster')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }